// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-devices/styles.less
// module id = 1163
// module chunks = 10